import { UITag } from '../../components'
import styled from 'styled-components'

export const Tag = styled(UITag)`
  font-size: 12px;
  line-height: 14px;
  padding: 2px 4px;
  margin: 0px 0px 8px 0px !important;
`
